import * as Types from "../constants/Module";

// ADD MODULES ACTIONS
export const addModule = (module) => ({
    type: Types.ADD_MODULE,
    payload: module
});

export const addModuleOk = () => ({
    type: Types.ADD_MODULE_OK,
})

export const addModuleFailed = (error) => ({
    type: Types.ADD_MODULE_FAILED,
    payload: error
})

// FETCH MODULES ACTIONS
export const fetchModules = () => ({
    type: Types.FETCH_MODULES
});

export const fetchModulesOk = (modules) => ({
    type: Types.FETCH_MODULES_OK,
    payload: modules
})

export const fetchModulesFailed = (error) => ({
    type: Types.FETCH_MODULES_FAILED,
    payload: error
})

// FETCH MODULE ID ACTIONS
export const fetchModuleId = (id) => ({
    type: Types.FETCH_MODULE_ID,
    payload: id
});

export const fetchModuleIdOk = (module) => ({
    type: Types.FETCH_MODULE_ID_OK,
    payload: module
})

export const fetchModuleIdFailed = (error) => ({
    type: Types.FETCH_MODULE_ID_FAILED,
    payload: error
})

// PATCH MODULE ACTIONS
export const patchModule = ({ module, id }) => ({
    type: Types.PATCH_MODULE,
    payload: { module, id }
});

export const patchModuleOk = () => ({
    type: Types.PATCH_MODULE_OK,
})

export const patchModuleFailed = (error) => ({
    type: Types.PATCH_MODULE_FAILED,
    payload: error
})